let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access 🔥",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$49",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Unlimited Access to VODs',
        trackLink: 'https://geekle.us/ticket/1664538463820x121330923563122690',
        data: 'April, 4th & 5th',
    },
    {
        id: 2,
        trackTitle: "Junior Track",
        trackSubtitle: "For Junior specialists",
        trackPrice: "FREE",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Junior Track',
        trackLink: 'https://geekle.us/ticketfree/1664537684360x140866356709949440',
        data: 'April, 4th',
    },
];

export default PackagesItem;
